import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, ScrollView, TouchableOpacity} from 'react-native';

import Colors from "../tools/Colors";
import {moderateScale} from "../tools/Scaling";
//import {Icon} from "native-base";
import HMTextView from "./HMTextView";
//import Icon from 'react-native-vector-icons/FontAwesome';

import {Tools} from "../tools/Tools";
import store from "../redux/store";
import HMIcon from "./HMIcon";


export default class HMDetailsMap extends Component {

    render() {
        const {style, text, icon, navigateParams,position} = this.props;
        let MyLocation = store.getState().reducerSplashGetAllData.Location;
        MyLocation = MyLocation && MyLocation.coords
        return (

            <View style={{
                flex: 1,
                // flexDirection: "column",
                // justifyContent: "center",
                // alignItems: "center",
            }}>
                {MyLocation && position && position.latitude && position.latitude != null ?
                    <View style={{
                        flex: 1,
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <View
                            style={{
                                width: '100%',
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: moderateScale(8),
                                marginBottom: moderateScale(8),

                            }}>
                            <View
                                style={{
                                    flexDirection: "row",
                                    marginRight: moderateScale(6),
                                    marginLeft: moderateScale(6),
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                <HMTextView
                                  text={!MyLocation ? " - " : Tools.GetDistanceMap({
                                      latitude: position.latitude ,
                                      longitude: position.longitude
                                  },MyLocation)}
                                    // text={!MyLocation ? " - " : Tools.GetDistanceMap({
                                    //     latitude: "34.1027629",
                                    //     longitude: "49.7205829"
                                    // }, MyLocation)}
                                    style={{
                                        marginEnd: moderateScale(5),
                                        fontSize: moderateScale(13),
                                        color: Colors.blackLight
                                    }}/>
                                <HMIcon name="md-git-pull-request" size={moderateScale(18)}
                                      style={{color: Colors.gray}}/>
                            </View>
                            <View
                                style={{flexDirection: "row", justifyContent: 'center', alignItems: 'center'}}>
                                <HMTextView
                                    //text={!MyLocation ? " - " : (Tools.GetTimeMap((state.distance)))}
                                    // text={!MyLocation ? " - " : Tools.GetTimeMap({
                                    //     latitude: "34.1027629",
                                    //     longitude: "49.7205829"
                                    // }, MyLocation)}
                                        text={!MyLocation ? " - " : Tools.GetTimeMap({
                                            latitude: position.latitude ,
                                            longitude: position.longitude
                                        }, MyLocation)}
                                    style={{
                                        marginEnd: moderateScale(5),
                                        fontSize: moderateScale(13),
                                        color: Colors.blackLight
                                    }}/>
                                <HMIcon name="md-walk" size={moderateScale(18)} style={{color: Colors.gray}}/>
                            </View>
                            <View
                                style={{
                                    flexDirection: "row",
                                    marginRight: moderateScale(6),
                                    marginLeft: moderateScale(6),
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                <HMTextView
                                    //  text={!MyLocation ? " - " : (Tools.GetTimeMap((.36 * state.distance)))}
                                      text={!MyLocation ? " - " : Tools.GetTimeMap({
                                          latitude: position.latitude ,
                                          longitude: position.longitude
                                      }, MyLocation,.22)}

                                    // text={!MyLocation ? " - " : Tools.GetTimeMap({
                                    //     latitude: "34.1027629",
                                    //     longitude: "49.7205829"
                                    // }, MyLocation, .36)}
                                    style={{
                                        marginEnd: moderateScale(5),
                                        fontSize: moderateScale(13),
                                        color: Colors.blackLight
                                    }}/>
                                <HMIcon name="md-car" size={moderateScale(18)} style={{color: Colors.gray}}/>
                            </View>
                        </View>
                        <View style={{width: "100%", height: 1, backgroundColor: Colors.light43, alignSelf: "center"}}/>

                    </View>
                    :
                    null

                }

            </View>
        );
    }

}
